
export default class ChartMaker {
  constructor () {
    this.data = null
    this.xml = null
  }

  static factory (type) {
    return new ChartMaker[type]()
  }
}



// WEBPACK FOOTER //
// ./src/factory/gbasechart.js